// @flow
import React, { useState, useEffect } from 'react';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { ChevronDown } from '@finect/tabular-icons/chevronDown';
import { Helmet } from 'react-helmet-async';
import {
  FAQWrapper,
  CategorySection,
  CategoryTitle,
  FAQItem,
  FAQHeader,
  FAQQuestion,
  FAQIcon,
  FAQContent,
  FAQAnswer
} from './partials';

const SingleFAQ = ({ question, answer }: { question: string, answer: any }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <FAQItem isOpen={isOpen}>
      <FAQHeader onClick={() => setIsOpen(!isOpen)}>
        <FAQQuestion>{question}</FAQQuestion>
        <FAQIcon isOpen={isOpen}>
          <ChevronDown />
        </FAQIcon>
      </FAQHeader>
      <FAQContent isOpen={isOpen}>
        <FAQAnswer dangerouslySetInnerHTML={{ __html: answer }} />
      </FAQContent>
    </FAQItem>
  );
};

type Props = {
  margin?: string
};

const PlusFAQBlock = ({ margin }: Props) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    finectAPI({
      version: 'v4',
      path: 'resources/setting/finect-plus-faqs',
      method: 'GET',
      onSuccess: (res) => {
        setCategories(res?.data?.value || []);
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
      }
    });
  }, []);

  if (loading) return <p>Cargando preguntas frecuentes...</p>;
  if (categories.length === 0) return null;

  const faqs = categories.reduce((acc, cat) => [...acc, ...cat.faqs || []], []);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: 'Preguntas frecuentes sobre Finect Plus',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <FAQWrapper margin={margin}>
        {categories.map((category, catIdx) => (
          <CategorySection key={catIdx}>
            <CategoryTitle>{category.title}</CategoryTitle>
            {category.faqs.map((faq, faqIdx) => (
              <SingleFAQ key={faqIdx} question={faq.question} answer={faq.answer} />
            ))}
          </CategorySection>
        ))}
      </FAQWrapper>
    </>
  );
};

export default PlusFAQBlock;
